import { handleActions } from 'redux-actions';
import { Map, OrderedSet } from 'immutable';

import actions from '../actions';

//REDUCERS
const { orderBy: orderByActions } = actions.customer;

export default handleActions(
  {
    [orderByActions.set.toString()]: (type, { payload }) => {
      return payload;
    }
  },
  Map({
    type: String('price'),
    orderedHotels: OrderedSet()
  })
);
